module.exports = __webpack_public_path__ + "static/fonts/Metropolis-SemiBold.7a550ea.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metropolis/Metropolis-SemiBold.woff
// module id = VU3v
// module chunks = 1